/* Hero carousel, including section reloads and block selection in Shopify. */
(function () {
  'use strict';
  if (window.HopeHeroSlider) { window.HopeHeroSlider.init(document); return; }
  var selector = '[id^="HeroBeltSlider-"]';
  function init(scope) {
    var roots = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root._hopeHero) return;
      var copies = root.querySelectorAll('.hbs-slide-copy');
      var cutouts = root.querySelectorAll('.hbs-cutout');
      var dots = root.querySelectorAll('.hbs-dot');
      var current = 0, timer = null, total = copies.length;
      function stop() { clearInterval(timer); timer = null; }
      function go(index) {
        if (!total) return;
        current = (index + total) % total;
        copies.forEach(function (el, i) { var active = i === current; el.classList.toggle('is-active', active); el.inert = !active; el.setAttribute('aria-hidden', String(!active)); });
        cutouts.forEach(function (el, i) { var active = i === current; el.classList.toggle('is-active', active); el.setAttribute('aria-hidden', String(!active)); });
        dots.forEach(function (el, i) { var active = i === current; el.classList.toggle('is-active', active); el.setAttribute('aria-current', String(active)); });
      }
      function start() {
        stop();
        if (total < 2 || root.dataset.autoplay !== 'true' || document.hidden || (window.Shopify && window.Shopify.designMode) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || root.matches(':focus-within')) return;
        timer = setInterval(function () { go(current + 1); }, parseInt(root.dataset.autoplaySpeed, 10) || 6000);
      }
      function manual(index) { stop(); go(index); }
      var previous = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
      if (previous) previous.addEventListener('click', function () { manual(current - 1); });
      if (next) next.addEventListener('click', function () { manual(current + 1); });
      dots.forEach(function (dot) { dot.addEventListener('click', function () { manual(+dot.dataset.slideIndex); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      var startX = null, startY = null, band = root.querySelector('.hbs-band');
      if (band) {
        band.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; startY = event.touches[0].clientY; }, { passive: true });
        band.addEventListener('touchend', function (event) {
          if (startX === null) return;
          var dx = event.changedTouches[0].clientX - startX, dy = event.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) manual(current + (dx < 0 ? 1 : -1));
          startX = startY = null;
        }, { passive: true });
      }
      root._hopeHero = { select: function (blockId) { copies.forEach(function (copy, i) { if (copy.dataset.blockId === blockId) manual(i); }); }, stop: stop, start: start };
      go(0); start();
    });
  }
  window.HopeHeroSlider = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll(selector).forEach(function (root) { if (root._hopeHero) root._hopeHero.stop(); }); });
  document.addEventListener('shopify:block:select', function (event) { var root = event.target.closest(selector); if (root && root._hopeHero && event.detail) root._hopeHero.select(event.detail.blockId); });
  document.addEventListener('visibilitychange', function () { document.querySelectorAll(selector).forEach(function (root) { if (root._hopeHero) root._hopeHero[document.hidden ? 'stop' : 'start'](); }); });
}());
